import Ajax from '../util/ajax';
export function fetchZigbeeNodeCluster(zigbee_node_id, endpoint_id, cluster_id, dir) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/ep/' + endpoint_id + '/cluster/' + cluster_id + '/' + dir;
        ajax.post(url, {});
    };
}
